// src/components/Layout/Navbar.js
import React, { useState } from 'react'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Avatar,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton
} from '@mui/material'
import {
  Home as HomeIcon,
  Search as SearchIcon,
  Dashboard as DashboardIcon,
  Login as LoginIcon,
  PersonAdd as PersonAddIcon,
  AccountCircle,
  Logout as LogoutIcon,
  AddHome as AddHomeIcon,
  Menu as MenuIcon,
  Business as BusinessIcon,
  Star as StarIcon,
  HourglassTop as PendingIcon,
  People as PeopleIcon,
  Article as ArticleIcon
} from '@mui/icons-material'
import { useAuth } from '../../context/AuthContext'
import { evento } from '../../analytics'

const Navbar = () => {
  const { user, logout } = useAuth()
  console.log('Navbar user:', user)
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    logout()
    handleClose()
    navigate('/')
  }

  const handleMobileMenuClick = (path) => {
    navigate(path)
    setMobileMenuOpen(false)
  }

  return (
    <AppBar
      position='sticky'
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'grey.200'
      }}
    >
      <Container maxWidth='xl'>
        <Toolbar sx={{ py: 1, justifyContent: 'space-between' }}>
          {/* Logo */}
          <Box
            component={RouterLink}
            to='/'
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              // sem isso o flex espreme o bloco do logo para caber os botoes
              flexShrink: 0,
              textDecoration: 'none'
            }}
          >
            <Box
              component='img'
              src='/logo_aux.png'
              alt='Logo'
              sx={{
                width: 40,
                height: 40,
                objectFit: 'contain'
              }}
            />
            <Box>
              <Typography
                variant='h6'
                sx={{
                  color: 'text.primary',
                  fontWeight: 700,
                  fontSize: '2rem',
                  lineHeight: 1,
                  // mb: -1 encostava a tagline DENTRO das letras: medido,
                  // a caixa da marca ia ate 48px e a tagline comecava em 40.
                  // Com lineHeight 1 a caixa ja e justa, o negativo so colide.
                  mb: 0.25
                }}
              >
                umarkt
              </Typography>
              <Typography
                variant='caption'
                sx={{
                  // display block + nowrap: como <span> inline ela quebrava em
                  // "certo" numa segunda linha e esticava a barra inteira
                  display: 'block',
                  color: 'text.secondary',
                  fontSize: '0.7rem',
                  lineHeight: 1,
                  fontStyle: 'italic',
                  whiteSpace: 'nowrap'
                }}
              >
                Seu imóvel no lugar certo
              </Typography>
            </Box>
          </Box>

          {/* Navigation Links */}
          <Box
            sx={{
              // lg, nao md. Medido: com todos os itens de usuario logado a
              // barra nao cabe em 900 nem em 1024 - a pagina passava a rolar
              // na horizontal. A partir de 1200 sobra folga.
              display: { xs: 'none', lg: 'flex' },
              gap: 1,
              alignItems: 'center'
            }}
          >
            <Button
              component={RouterLink}
              to='/'
              startIcon={<HomeIcon />}
              sx={{
                color: 'text.primary',
                px: 2,
                whiteSpace: 'nowrap',
                '&:hover': { bgcolor: 'grey.100' }
              }}
            >
              Início
            </Button>
            <Button
              component={RouterLink}
              to='/para-profissionais'
              startIcon={<BusinessIcon />}
              sx={{
                color: 'text.primary',
                px: 2,
                whiteSpace: 'nowrap',
                '&:hover': { bgcolor: 'grey.100' }
              }}
            >
              Corretores e Imobiliárias
            </Button>
            <Button
              component='a'
              href='/blog/'
              startIcon={<ArticleIcon />}
              sx={{
                color: 'text.primary',
                px: 2,
                whiteSpace: 'nowrap',
                '&:hover': { bgcolor: 'grey.100' }
              }}
            >
              Blog
            </Button>

            {user ? (
              <>
                <Button
                  component={RouterLink}
                  to='/dashboard'
                  startIcon={<DashboardIcon />}
                  sx={{
                    color: 'text.primary',
                    px: 2,
                    whiteSpace: 'nowrap',
                    '&:hover': { bgcolor: 'grey.100' }
                  }}
                >
                  Meus Anúncios
                </Button>
                {/* "Painel do Corretor" foi removido daqui: apontava para
                    /dashboard, exatamente como "Meus Anuncios" logo acima, e o
                    menu do avatar ja tem "Dashboard". Eram tres portas para a
                    mesma sala, disputando espaco na barra. Aparecia tambem
                    para quem nao e corretor. */}
                <Divider orientation='vertical' flexItem sx={{ mx: 1 }} />
                <IconButton
                  onClick={handleMenu}
                  sx={{
                    ml: 1,
                    '&:hover': { bgcolor: 'grey.100' }
                  }}
                >
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      bgcolor: 'primary.main',
                      fontSize: '1rem',
                      fontWeight: 600
                    }}
                  >
                    {user.email?.[0]?.toUpperCase() || 'U'}
                  </Avatar>
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1.5,
                      minWidth: 200,
                      borderRadius: 2,
                      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <Box sx={{ px: 2, py: 1.5 }}>
                    <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
                      {user.email}
                    </Typography>
                  </Box>
                  <Divider />
                  <MenuItem
                    component={RouterLink}
                    to='/dashboard'
                    onClick={handleClose}
                    sx={{ py: 1.5, gap: 1.5 }}
                  >
                    <DashboardIcon fontSize='small' />
                    Dashboard
                  </MenuItem>
                  {user?.is_staff && (
                    <MenuItem
                      component={RouterLink}
                      to='/painel/destaques'
                      onClick={handleClose}
                      sx={{ py: 1.5, gap: 1.5 }}
                    >
                      <StarIcon fontSize='small' sx={{ color: '#FF7F27' }} />
                      Gerenciar Destaques
                    </MenuItem>
                  )}
                  {user?.is_staff && (
                    <MenuItem
                      component={RouterLink}
                      to='/painel/aprovacoes'
                      onClick={handleClose}
                      sx={{ py: 1.5, gap: 1.5 }}
                    >
                      <PendingIcon fontSize='small' sx={{ color: '#FF9800' }} />
                      Aprovar Anúncios
                    </MenuItem>
                  )}
                  {user?.is_staff && (
                    <MenuItem
                      component={RouterLink}
                      to='/painel/imoveis'
                      onClick={handleClose}
                      sx={{ py: 1.5, gap: 1.5 }}
                    >
                      <HomeIcon fontSize='small' sx={{ color: '#607D8B' }} />
                      Gerenciar Imóveis
                    </MenuItem>
                  )}
                  {user?.is_staff && (
                    <MenuItem
                      component={RouterLink}
                      to='/painel/usuarios'
                      onClick={handleClose}
                      sx={{ py: 1.5, gap: 1.5 }}
                    >
                      <PeopleIcon fontSize='small' sx={{ color: '#4CAF50' }} />
                      Gerenciar Usuários
                    </MenuItem>
                  )}
                  <MenuItem
                    component={RouterLink}
                    to='/minha-conta'
                    onClick={handleClose}
                    sx={{ py: 1.5, gap: 1.5 }}
                  >
                    <AccountCircle fontSize='small' />
                    Minha Conta
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={handleLogout}
                    sx={{
                      py: 1.5,
                      gap: 1.5,
                      color: 'error.main'
                    }}
                  >
                    <LogoutIcon fontSize='small' />
                    Sair
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button
                  component={RouterLink}
                  to='/login'
                  startIcon={<LoginIcon />}
                  sx={{
                    color: 'text.primary',
                    px: 2,
                    whiteSpace: 'nowrap',
                    '&:hover': { bgcolor: 'grey.100' }
                  }}
                >
                  Entrar
                </Button>
                <Button
                  component={RouterLink}
                  to='/registro'
                  variant='outlined'
                  startIcon={<PersonAddIcon />}
                  sx={{
                    px: 2,
                    whiteSpace: 'nowrap',
                    borderColor: 'grey.300',
                    color: 'text.primary',
                    '&:hover': {
                      borderColor: 'primary.main',
                      bgcolor: 'grey.50'
                    }
                  }}
                >
                  Cadastrar
                </Button>
              </>
            )}

            {/* CTA Button */}
            <Button
              component={RouterLink}
              to={user ? '/dashboard/novo-imovel' : '/login'}
              variant='contained'
              startIcon={<AddHomeIcon />}
              onClick={() => evento('anunciar_clique', { logado: Boolean(user), origem: 'navbar' })}
              sx={{
                ml: 2,
                px: 2.5,
                py: 1.1,
                // era 1rem contra 0.875rem dos demais: sendo o maior rotulo da
                // barra, era sempre o primeiro a quebrar em duas linhas
                fontSize: '0.95rem',
                fontWeight: 600,
                whiteSpace: 'nowrap'
              }}
            >
              Anunciar Imóvel
            </Button>
          </Box>

          {/* Botão Anunciar + Menu Hamburguer (Mobile) */}
          {/* Espelha o corte acima: ate 1199 vale o menu hamburguer */}
          <Box sx={{ display: { xs: 'flex', lg: 'none' }, alignItems: 'center', gap: 1 }}>
            <Button
              component={RouterLink}
              to={user ? '/dashboard/novo-imovel' : '/login'}
              variant='contained'
              size='small'
              startIcon={<AddHomeIcon />}
              sx={{
                fontWeight: 700,
                fontSize: '0.78rem',
                px: 1.5,
                py: 0.8,
                bgcolor: '#FF7F27',
                '&:hover': { bgcolor: '#e06b1a' }
              }}
            >
              Anunciar
            </Button>
            <IconButton
              sx={{ color: 'text.primary' }}
              onClick={() => setMobileMenuOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </Container>

      {/* Drawer Mobile */}
      <Drawer
        anchor='left'
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        sx={{
          display: { xs: 'block', md: 'none' }
        }}
      >
        <Box sx={{ width: 280, pt: 2 }}>
          {/* User Info (se logado) */}
          {user && (
            <Box sx={{ px: 2, py: 2, mb: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar
                  sx={{
                    width: 48,
                    height: 48,
                    bgcolor: 'primary.main',
                    fontSize: '1.2rem'
                  }}
                >
                  {user.email?.[0]?.toUpperCase() || 'U'}
                </Avatar>
                <Box>
                  <Typography variant='subtitle1' sx={{ fontWeight: 600 }}>
                    {user.email}
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          <Divider />

          {/* Menu Items */}
          <List sx={{ pt: 1 }}>
            <ListItemButton onClick={() => handleMobileMenuClick('/')}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary='Início' />
            </ListItemButton>

            <ListItemButton
              onClick={() => handleMobileMenuClick('/para-profissionais')}
            >
              <ListItemIcon>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText primary='Corretores e Imobiliárias' />
            </ListItemButton>

            <ListItemButton
              component='a'
              href='/blog/'
              onClick={() => setMobileMenuOpen(false)}
            >
              <ListItemIcon>
                <ArticleIcon />
              </ListItemIcon>
              <ListItemText primary='Blog' />
            </ListItemButton>

            {user ? (
              <>
                <ListItemButton
                  onClick={() => handleMobileMenuClick('/dashboard')}
                >
                  <ListItemIcon>
                    <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary='Dashboard' />
                </ListItemButton>

                <ListItemButton
                  onClick={() => handleMobileMenuClick('/minha-conta')}
                >
                  <ListItemIcon>
                    <AccountCircle />
                  </ListItemIcon>
                  <ListItemText primary='Minha Conta' />
                </ListItemButton>

                {user?.is_staff && (
                  <ListItemButton
                    onClick={() => handleMobileMenuClick('/painel/destaques')}
                  >
                    <ListItemIcon>
                      <StarIcon sx={{ color: '#FF7F27' }} />
                    </ListItemIcon>
                    <ListItemText primary='Gerenciar Destaques' />
                  </ListItemButton>
                )}
                {user?.is_staff && (
                  <ListItemButton
                    onClick={() => handleMobileMenuClick('/painel/aprovacoes')}
                  >
                    <ListItemIcon>
                      <PendingIcon sx={{ color: '#FF9800' }} />
                    </ListItemIcon>
                    <ListItemText primary='Aprovar Anúncios' />
                  </ListItemButton>
                )}
                {user?.is_staff && (
                  <ListItemButton
                    onClick={() => handleMobileMenuClick('/painel/imoveis')}
                  >
                    <ListItemIcon>
                      <HomeIcon sx={{ color: '#607D8B' }} />
                    </ListItemIcon>
                    <ListItemText primary='Gerenciar Imóveis' />
                  </ListItemButton>
                )}
                {user?.is_staff && (
                  <ListItemButton
                    onClick={() => handleMobileMenuClick('/painel/usuarios')}
                  >
                    <ListItemIcon>
                      <PeopleIcon sx={{ color: '#4CAF50' }} />
                    </ListItemIcon>
                    <ListItemText primary='Gerenciar Usuários' />
                  </ListItemButton>
                )}

                <ListItemButton
                  onClick={() =>
                    handleMobileMenuClick(
                      user ? '/dashboard/novo-imovel' : '/login'
                    )
                  }
                >
                  <ListItemIcon>
                    <AddHomeIcon />
                  </ListItemIcon>
                  <ListItemText primary='Anunciar Imóvel' />
                </ListItemButton>

                <Divider sx={{ my: 1 }} />

                <ListItemButton
                  onClick={() => {
                    logout()
                    setMobileMenuOpen(false)
                    navigate('/')
                  }}
                >
                  <ListItemIcon>
                    <LogoutIcon color='error' />
                  </ListItemIcon>
                  <ListItemText primary='Sair' sx={{ color: 'error.main' }} />
                </ListItemButton>
              </>
            ) : (
              <>
                <Divider sx={{ my: 1 }} />

                <ListItemButton onClick={() => handleMobileMenuClick('/login')}>
                  <ListItemIcon>
                    <LoginIcon />
                  </ListItemIcon>
                  <ListItemText primary='Entrar' />
                </ListItemButton>

                <ListItemButton
                  onClick={() => handleMobileMenuClick('/registro')}
                >
                  <ListItemIcon>
                    <PersonAddIcon />
                  </ListItemIcon>
                  <ListItemText primary='Cadastrar' />
                </ListItemButton>

                <Divider sx={{ my: 1 }} />

                <ListItemButton
                  onClick={() => handleMobileMenuClick('/login')}
                  sx={{
                    bgcolor: 'primary.main',
                    color: 'white',
                    mx: 2,
                    borderRadius: 1,
                    '&:hover': {
                      bgcolor: 'primary.dark'
                    }
                  }}
                >
                  <ListItemIcon>
                    <AddHomeIcon sx={{ color: 'white' }} />
                  </ListItemIcon>
                  <ListItemText primary='Anunciar Imóvel' />
                </ListItemButton>
              </>
            )}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  )
}

export default Navbar
